import React from "react";
import {DoppeViewerFormField} from "../doppe-viewer-form-field/doppe-viewer-form-field";
import {DoppeActionWidgetTextBox} from "../doppe-action-widget-text-box/doppe-action-widget-text-box";
import {FlexLayout} from "@wix/devzai-common-client";
import {Icon} from "@wix/devzai-utils-react";
import IconChevronDown
    from "../doppe-action-button-templates/doppe-standard-action-button-template/icons/ChevronDown.svg";
import {classes, style} from './doppe-payment-element-dummy.st.css';
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";

export const DoppePaymentElementDummy = React.memo((props: DoppePaymentElementDummy.Props) => {
    const {
        onLoaderStart
    } = props;

    React.useEffect(() => {
        onLoaderStart?.();
    }, [onLoaderStart]);

    const doppeViewerLocales = useDoppeViewerLocales();

    return (
        <div className={classes.root}>
            <DoppeViewerFormField
                label={doppeViewerLocales['cardNumber']}
            >
                <DoppeActionWidgetTextBox
                    className={style(classes.input, {})}
                    hasError={false}
                    shouldValidateValue={false}
                    placeholder={'1234 1234 1234 1234'}
                />
            </DoppeViewerFormField>
            <div className={style(classes.inputRow, FlexLayout.row.alignToCenter)}>
                <DoppeViewerFormField
                    className={style(classes.formField, {}, FlexLayout.fillRemainingHorizontalSpace)}
                    label={doppeViewerLocales['cardExpiration']}
                >
                    <DoppeActionWidgetTextBox
                        className={style(classes.input, {})}
                        hasError={false}
                        shouldValidateValue={false}
                        placeholder={doppeViewerLocales['cardExpirationyPlaceholder']}
                    />
                </DoppeViewerFormField>
                <DoppeViewerFormField
                    className={style(classes.formField, {}, FlexLayout.fillRemainingHorizontalSpace)}
                    label={doppeViewerLocales['cardCVC']}
                >
                    <DoppeActionWidgetTextBox
                        className={style(classes.input, {})}
                        hasError={false}
                        shouldValidateValue={false}
                        placeholder={doppeViewerLocales['cardCVC']}
                    />
                </DoppeViewerFormField>
            </div>
            <DoppeViewerFormField
                label={doppeViewerLocales['cardCountry']}
            >
                <DoppeActionWidgetTextBox
                    className={style(classes.input, {})}
                    hasError={false}
                    shouldValidateValue={false}
                    placeholder={doppeViewerLocales['cardCountry']}
                    suffixContent={
                        <Icon
                            className={style(classes.chevronIcon, {})}
                            icon={IconChevronDown}
                        />
                    }
                />
            </DoppeViewerFormField>
        </div>
    );
});

export namespace DoppePaymentElementDummy {

    export interface Props {
        onLoaderStart?: () => void;
    }
}
